module.exports = __webpack_public_path__ + "static/media/face6.07adc9a9.jpg";